// Signin.js
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { UserContext } from '../userContext/UserContext';
import { getSasToken } from '../../services/apiService';
import Logo from '../../assets/images/logo.png';
import MicrosoftLogo from '../../assets/images/microsoft.png';
import './signin.css';

const Signin = () => {
    const navigate = useNavigate();
    const { instance } = useMsal();
    const { setUserName, setUserId, setRole, setSasToken, userName } = useContext(UserContext);
    const [isLoginComplete, setIsLoginComplete] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleMicrosoftSignin = async () => {
        setIsLoading(true);
        try {
            // Microsoft login popup
            const loginResponse = await instance.loginPopup({
                scopes: ['openid', 'profile', 'User.Read'],
            });

            const account = loginResponse.account;
            const userRole = account.idTokenClaims?.roles?.[0] || 'Role.User';

            // Update user context and local storage with user info
            setUserName(account.name);
            setUserId(account.username);
            setRole(userRole);

            localStorage.setItem('userName', account.name);
            localStorage.setItem('userId', account.username);
            localStorage.setItem('role', userRole);

            // Fetch and store SAS token from your API
            const token = await getSasToken();
            setSasToken(token); // update context
            localStorage.setItem('sasToken', token);

            // Set expiration for SAS token: 2 weeks from now
            const tokenExpiry = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString();
            localStorage.setItem('sasTokenExpiry', tokenExpiry);

            setIsLoginComplete(true);
        } catch (error) {
            console.error('Error during Microsoft sign-in or SAS token fetching:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isLoginComplete && userName) {
            navigate('/dashboard');
        }
    }, [isLoginComplete, userName, navigate]);

    return (
        <div className="signin-container">
            <header className="signin-header">
                <img src={Logo} alt="SPM Logo" className="signin-logo" />
                <div className="title">Open Issues</div>
            </header>

            <div className="signin-content">
                <button
                    className="microsoft-button"
                    onClick={handleMicrosoftSignin}
                    disabled={isLoading}
                >
                    <img src={MicrosoftLogo} alt="Microsoft logo" className="microsoft-logo" />
                    <span className="microsoft-text">{isLoading ? 'Signing in...' : 'Sign in with Microsoft'}</span>
                </button>
            </div>
        </div>
    );
};

export default Signin;
